<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
    <template #INQUIRE="{ visible, params }">
      <Form v-if="visible" inline class="bill-form">
        <FormItem>
          <Input
            type="textarea"
            v-model="params.keywords"
            :placeholder="$t('keyword')"
          >
          </Input>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="SearchSubmit(params.keywords)"
            icon="md-search"
          >
            {{ $t("search") }}
          </Button>
        </FormItem>
        <FormItem>
          <Button type="primary" icon="md-arrow-down" @click="exportExc">
            {{ $t("export") }}
          </Button>
        </FormItem>
      </Form>
    </template>
    <template #SHOW="{ visible, params }">
      <PackageDetails v-if="visible" :itemId="params.id"></PackageDetails>
    </template>
    <template #PACKAGE="{ visible, params }">
      <PackageOpe v-if="visible" :itemId="params.id"></PackageOpe>
    </template>
  </cTable>
</template>

<script>
import { getPackage, add, exportCargo } from "@/api/order/package";
import { showPackage } from "@/api/order/package";
import PackageOpe from "_my/package-ope";
import PackageDetails from "_my/package-details";
import { getWarehouse } from "@/api/storage/warehouse";
import cTable from "@/base/common/index";
export default {
  name: "packageOrder",
  components: {
    cTable,
    PackageOpe,
    PackageDetails
  },
  mounted() {
    // this.header.searchs.forEach(async item => {
    //   if (item.key === "warehouse_id")
    //     item.options = (await getWarehouse()).data.payload.rows;
    // });
  },
  methods: {
    SearchSubmit(val) {
      let that = this.$refs["table"].getModal("inquire");
      that.pageConfig.data = { keywords: val };
      that.getList();
    },
    exportExc() {
      let that = this.$refs["table"].getModal("inquire");
      this.$refs["table"].exportExc({
        data: that.selectAll.length ? that.selectAll : that.list,
        fields: that.table.fields,
        name: that.$t("combinedEnquiry")
      });
    }
  },
  data() {
    return {
      methods: {
        list: getPackage,
        add,
        showPackage,
        exportCargo
      },
      config: {
        height: 630
      },
      modals: {
        show: {
          contentSlot: "SHOW",
          footer: {
            show: false
          },
          config: {
            modalBind: {
              width: "50%"
            }
          }
        },
        package: {
          contentSlot: "PACKAGE",
          footer: {
            show: false
          },
          config: {
            modalBind: {
              width: 70,
              styles: {
                top: "50px"
              }
            }
          }
        },
        inquire: {
          contentSlot: "INQUIRE",
          // methods: {
          //   cancel() {
          //     this.$page.getList();
          //   }
          // },
          footer: {
            show: false
          },
          config: {
            title: "combinedEnquiry",
            listFn: "showPackage",
            modalBind: {
              width: "80%"
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [
            {
              transfer_pickup_id: 8,
              add: 2
            }
          ],
          fields: [],
          table: {
            footer: {
              show: true
            },
            config: {
              align: "center",
              height: 500
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60
              },
              {
                name: () => this.$t("cargoNumber1"),
                key: "cargoNumber",
                align: "center",
                tooltip: true,
                minWidth: 80
              },
              {
                name: () => this.$t("virtual_airway_number"),
                key: "virtual_airway_number",
                align: "center",
                tooltip: true,
                minWidth: 95
              },
              {
                name: () => this.$t("old") + this.$t("order_number"),
                key: "airway_bill",
                align: "center",
                tooltip: true,
                minWidth: 95
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   searchForm.startTime = searchForm.startTime
              //     ? this.$page.format.timeFormat(searchForm.startTime)
              //     : "";
              // }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm["endTime"] = time;
              //   }
              // }
            }
          },
          {
            key: "warehouse_id",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id"
            },
            methods: {
              async list({ field }) {
                field.options = (
                  await getWarehouse({ is_oversea: "NO" })
                ).data.payload.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("combinedEnquiry"),
              type: "inquire",
              fnName: "inquireFun",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              let exportList = [
                {
                  name: this.$t("virtual_airway_number"),
                  key: "virtual_airway_number"
                },
                {
                  name: this.$t("old") + this.$t("Odd_Numbers"),
                  key: "airway_bill"
                },
                {
                  name: this.$t("bagNum"),
                  key: "package_number"
                },
                {
                  name: this.$t("packing_number"),
                  key: "packing_number"
                }
              ];
              this.openLoading();
              this.handleRequestMethods(
                "exportCargo",
                {
                  cargo_id: this.selectAll.map(item => {
                    return item.id;
                  })
                },
                false,
                true
              ).then(res => {
                if (!res.payload.length) {
                  this.$Message["error"]({
                    background: true,
                    content: this.$t("Not") + this.$t("data"),
                    duration: 5
                  });
                  return false;
                }
                this.exportExc({
                  data: res.payload,
                  fields: exportList,
                  name: this.$t("packageOrder")
                });
              });
            },
            addFun() {
              console.log("addFun");
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("add") +
                  this.$t("package1") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("add", {}, true).then(res => {
                    this.getList();
                  });
                }
              });
            },
            inquireFun() {
              this.getModal("inquire").open(
                {
                  keyword: ""
                },
                function() {
                  this.getList();
                }
              );
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          width: 170,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("cargoNumber1"),
          key: "cargoNumber",
          align: "center",
          minWidth: 150
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("operWarehouse"),
          key: "warehouseTitle",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("total_votes1"),
          key: "cargo_total",
          align: "center",
          minWidth: 100
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("show"),
              type: "show",
              fnName: "showFun",
              bind: {
                type: "primary"
              },
              disabled({ row }) {
                return row.cargo_total < 1 ? true : false;
              }
            },
            {
              name: () => this.$t("package1"),
              type: "package",
              fnName: "package1Fun",
              bind: {
                type: "warning"
              }
            }
          ],

          methods: {
            async showFun({ row }) {
              this.getModal("show").open({ id: row.id }, function() {
                this.setTitle(row.cargoNumber);
              });
            },
            package1Fun({ row }) {
              this.getModal("package").open({ id: row.id }, function() {
                this.setTitle(row.cargoNumber);
              });
            }
          }
        }
      ]
    };
  }
};
</script>
